import React from "react";
import "./Repay.css";
import logo from "../../images/loanwalle_logo_blue_bg.png";
import qrCode from "../../images/qr_code.png";

const Repay = () => {
  return (
    <div className="repay-container">
      <div className="repay-content">
        <div className="logo-section">
          <img src={logo} alt="Loanwalle Logo" className="repay-logo" />
        </div>
        
        <div className="qr-section">
          <h2>💳 Quick Repayment</h2>
          <p className="section-subtitle">
            Scan the QR code below to complete your payment securely
          </p>
          
          <div className="qr-container">
            <div className="qr-header">
              <span className="qr-icon">📱</span>
              <span className="qr-label">Payment QR Code</span>
            </div>
            <img src={qrCode} alt="QR Code for Payment" className="qr-code" />
          </div>
          
          <div className="payment-info">
            <div className="info-item">
              <span className="info-icon">🔒</span>
              <span>Secure Payment Gateway</span>
            </div>
            <div className="info-item">
              <span className="info-icon">⚡</span>
              <span>Instant Processing</span>
            </div>
            <div className="info-item">
              <span className="info-icon">✅</span>
              <span>24/7 Available</span>
            </div>
          </div>
          
          <p className="qr-description">
            Use any UPI-enabled payment app to scan this QR code and complete your repayment instantly
          </p>
        </div>
      </div>
    </div>
  );
};

export default Repay; 